import React, { useEffect } from 'react';
import {
    BrowserRouter as Router,
    Route,
    Redirect,
    Switch
} from 'react-router-dom';

import { Welcome } from 'components/Welcome';
import { Wrapper as NewWrapper } from 'components/Wrapper';
import { Wrapper as LegacyWrapper } from 'legacy_components/Wrapper';

import { useFetch } from 'helpers/hooks';
import { useAppStore } from 'helpers/useAppStore';

import 'index.css';

/* =========================
   Private Route Component
========================= */

const PrivateRoute = ({ ...rest }) => {
    const token = localStorage.getItem('DocspointJWT');
    const setIsLegacy = useAppStore((state) => state.setIsLegacy);
    const isLegacy = useAppStore((state) => state.isLegacy);

    const { data: user, loading, error } = useFetch(
        token ? '/rest-auth/user/' : null
    );

    useEffect(() => {
        if (!user) return;

        const legacyFlag = user?.legacy_frontend === true;
        setIsLegacy(legacyFlag);

        const existingLink = document.getElementById('dynamic-theme');
        if (existingLink) existingLink.remove();

        const link = document.createElement('link');
        link.id = 'dynamic-theme';
        link.rel = 'stylesheet';
        link.href = legacyFlag
            ? '/legacy_index.css'
            : '/index.css';

        document.head.appendChild(link);
    }, [user, setIsLegacy]);

    if (!token) {
        return <Redirect to="/auth/login" />;
    }

    if (loading) return null;

    if (error) {
        localStorage.removeItem('DocspointJWT');
        return <Redirect to="/auth/login" />;
    }

    const ComponentToRender = isLegacy
        ? LegacyWrapper
        : NewWrapper;

    return (
        <Route
            {...rest}
            render={(props) => <ComponentToRender {...props} />}
        />
    );
};

/* =========================
   App Component
========================= */

export const App = () => {

    useEffect(() => {
        // Matomo Tag Manager init
        window._mtm = window._mtm || [];
        window._mtm.push({
            'mtm.startTime': new Date().getTime(),
            event: 'mtm.Start'
        });

        const script = document.createElement('script');
        script.async = true;
        script.src =
            'https://cdn.matomo.cloud/brandhub.matomo.cloud/container_m8OVrIoy.js';

        document.head.appendChild(script);

        return () => {
            document.head.removeChild(script);
        };
    }, []);

    return (
        <Router>
            <Switch>
                <Route path="/auth">
                    {({ history }) => (
                        <Welcome history={history} />
                    )}
                </Route>

                <PrivateRoute path="/" />
            </Switch>
        </Router>
    );
};